<article
  class="message-item"
  [class.message-item--user]="message.role === messageRole.USER"
  [class.message-item--assistant]="message.role === messageRole.ASSISTANT"
  [class.message-item--system]="message.role === messageRole.SYSTEM"
  [class.message-item--pending]="!!message.pending"
>
  <div class="message-item__bubble">
    <div class="message-item__content">
      <p class="message-item__thinking" *ngIf="message.pending; else messageBlocks" aria-live="polite">
        <span class="message-item__thinking-label">Thinking</span>
        <span class="message-item__thinking-dots" aria-hidden="true"><i></i><i></i><i></i></span>
      </p>

      <ng-template #messageBlocks>
        <talk-to-your-data-message-renderer
          class="message-item__block"
          *ngFor="let block of message.blocks"
          [block]="block"
        ></talk-to-your-data-message-renderer>
      </ng-template>
    </div>

    <ng-container *ngIf="!message.pending">
      <hr class="message-item__divider" />

      <footer class="message-item__footer">
        <time
          class="message-item__meta"
          [class]="message.role === messageRole.ASSISTANT ? 'left-aligned' : ''"
          [attr.datetime]="message.createdAt"
          >{{ message.createdAt | date: 'shortTime' }}</time
        >
        <span class="message-item__actions" *ngIf="message.role === messageRole.ASSISTANT">
          <!-- <cwc-button
            class="message-item__action-button"
            *ngIf="liked"
            type="button"
            variant="icon"
            aria-label="Like response"
            leading-icon="like-filled"
            (click)="onLike()"
          >
          </cwc-button> -->
          <!-- <cwc-button
            class="message-item__action-button"
            *ngIf="!liked"
            type="button"
            variant="icon"
            aria-label="Like response"
            leading-icon="like-outlined"
            (click)="onLike()"
          >
          </cwc-button>

          <cwc-button
            class="message-item__action-button"
            *ngIf="disliked"
            type="button"
            variant="icon"
            aria-label="Dislike response"
            leading-icon="dislike-filled"
            (click)="onDislike()"
          >
          </cwc-button>
          <cwc-button
            class="message-item__action-button"
            *ngIf="!disliked"
            type="button"
            variant="icon"
            aria-label="Dislike response"
            leading-icon="dislike-outlined"
            (click)="onDislike()"
          >
          </cwc-button> -->

          <!-- <cwc-button
            class="action-item__repeat message-item__action-button"
            type="button"
            variant="icon"
            aria-label="Repeat"
            leading-icon="repeat"
          >
          </cwc-button> -->
          <cwc-button
            class="message-item__action-button"
            type="button"
            variant="icon"
            aria-label="Copy response"
            leading-icon="copy"
            (click)="onCopy()"
          >
          </cwc-button>
        </span>
      </footer>
    </ng-container>
  </div>
</article>
